import { BellOff } from "lucide-react"
import { useTranslation } from "react-i18next"

import { EmptyState } from "@/components/empty-state"
import { MOTION_BEATS } from "@/lib/motion"
import { cn } from "@/lib/utils"

/**
 * OKS-36 / OKS-405 — Notifications "all caught up" empty state.
 *
 * Thin wrapper over the shared `EmptyState` primitive (OKS-405 converged
 * the four creator empty surfaces onto it). Consumed by BOTH the full
 * `/notifications` page and the bell panel/sheet, so the public name +
 * `data-testid` are preserved.
 *
 * `role="status"` so assistive tech announces the arrival moment on
 * land. No CTA per UX Spec §3 — an empty inbox is a moment of arrival,
 * not a workflow prompt — and no brand name (the surface is
 * brand-agnostic). Plays the `overlay-enter` motion beat once on mount
 * (motion-safe; collapses for reduced-motion users).
 *
 * `compact` tightens the vertical padding for the dropdown panel, where
 * the page-scale `py-16` would be too tall.
 */
export function NotificationsEmptyState({
  compact = false,
}: {
  compact?: boolean
}) {
  const { t } = useTranslation()
  return (
    <EmptyState
      icon={BellOff}
      title={t("notifications.empty.title")}
      role="status"
      data-testid="notifications-empty-state"
      className={cn(MOTION_BEATS["overlay-enter"], compact && "py-10")}
    />
  )
}
